import { render, staticRenderFns } from "./ModalConfirmCreateOrderEmergency.vue?vue&type=template&id=ba5546fc&scoped=true"
import script from "./ModalConfirmCreateOrderEmergency.vue?vue&type=script&lang=js"
export * from "./ModalConfirmCreateOrderEmergency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5546fc",
  null
  
)

export default component.exports